import React, { useMemo } from 'react';

//@ts-ignore
import { asNumber, guessType } from '@rjsf/core/lib/utils';
import { Select } from 'semantic-ui-react';
import { useSchemaTranslation } from '../../../useSchemaTranslation';

const nums = new Set(['number', 'integer']);

/**
 * This is a silly limitation in the DOM where option change event values are
 * always retrieved as strings.
 */
const processValue = (schema: any, value: any) => {
  // "enum" is a reserved word, so only "type" and "items" can be destructured
  const { type, items } = schema;
  if (value === '') {
    return undefined;
  } else if (type === 'array' && items && nums.has(items.type)) {
    return value.map(asNumber);
  } else if (type === 'boolean') {
    return value === 'true';
  } else if (type === 'number') {
    return asNumber(value);
  }

  // If type is undefined, but an enum is present, try and infer the type from
  // the enum values
  if (schema.enum) {
    if (schema.enum.every((x: any) => guessType(x) === 'number')) {
      return asNumber(value);
    } else if (schema.enum.every((x: any) => guessType(x) === 'boolean')) {
      return value === 'true';
    }
  }

  return value;
};

const SelectWidget = ({
  schema,
  id,
  options,
  label,
  required,
  disabled,
  readonly,
  value,
  multiple,
  autofocus,
  onChange,
  onBlur,
  onFocus,
}: any) => {
  const { enumOptions, enumDisabled, semanticProps = {} } = options;
  const { t } = useSchemaTranslation()
  const emptyValue = multiple ? [] : '';

  const _onChange = (e: any, { value }: any) => {
    onChange(processValue(schema, value));
  }

  const _onBlur = (e: any, { value }: any) => {
    onBlur(id, processValue(schema, value));
  }

  const _onFocus = (e: any, { value }: any) => {
    onFocus(id, processValue(schema, value));
  }

  const semanticOptions = useMemo(() => {
    return (enumOptions as any).map(({ value, label }: any, i: number) => {
      const disabled: any = enumDisabled && (enumDisabled as any).indexOf(value) != -1; // eslint-disable-line
      return ({
        key: i,
        value,
        disabled,
        text: t(label)
      });
    })
  }, [enumOptions, enumDisabled, t])

  return (
    <Select
      fluid
      label={null}
      options={semanticOptions}
      value={typeof value === 'undefined' ? emptyValue : value}
      multiple={typeof multiple === 'undefined' ? false : multiple}
      required={required}
      disabled={disabled || readonly}
      autoFocus={autofocus}
      onChange={_onChange}
      onBlur={_onBlur}
      onFocus={_onFocus}
      {...semanticProps}
    />
  )

};

export default SelectWidget;
